module.exports = __webpack_public_path__ + "static/media/musement_logo.d2a07d95.svg";